import { render } from "./ResourceDetailsPanel.vue?vue&type=template&id=23995e44"
import script from "./ResourceDetailsPanel.vue?vue&type=script&lang=js"
export * from "./ResourceDetailsPanel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__